<template>
    <div class="field">
        <label class="label">Fisker</label>
        <div class="control">
            <div class="select-container">
                <i :class="{ 'fa fa-spinner fa-spin': this.isLoading }" />
                <select class="input select" required v-model="localCatcher">
                    <option v-for="c in catchers" :value="c" :key="c.id">{{ c.name }}</option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'CatcherSelector',
    props: { catcher: Object },
    data() {
        return {
            localCatcher: this.catcher,
        };
    },
    watch: {
        catcher(catcher) {
            // An existing catch finishes loading and sends it's data to us
            this.localCatcher = catcher;
        },
        localCatcher(catcher) {
            if (catcher === this.catcher) return;
            // Our user updates our catcher through input
            this.$emit('updateCatcher', catcher); // Notify parent
        },
    },
    computed: {
        ...mapState('session', ['catchers', 'isLoading']),
    },
};
</script>

<style></style>
